import React from 'react';
import { AIOrderingDashboardWithProvider } from '../../basicOrganizationApplications/components/AIOrderingDashboard';
import { AppNameMap, EntityNameMap } from '../../../../../shared/utils/engagementAnalyticsTransformers';
import PlatformDashboardShell from './PlatformDashboardShell';
import { PlatformOrganizationItemModel } from './PlatformOrganizationItem';
import PlatformOrderingManagement from './PlatformOrderingManagement';

interface PlatformOrderingDashboardContentProps {
    organizations: PlatformOrganizationItemModel[];
    managementOrganizations: PlatformOrganizationItemModel[];
    appNameMap: AppNameMap;
    entityNameMap: EntityNameMap;
    representativeAppId?: string;
    platformAppIdsByOrganizationId: Record<string, string[]>;
    selectedAppLiveStatusMap?: Record<string, boolean>;
    canManageQueues: boolean;
    currentUserEmail: string;
    loadErrors?: string[];
    discoveryProgress?: {
        loadedCount: number;
        totalCount: number;
        isComplete: boolean;
        hasErrors: boolean;
    };
    onReload?: () => void;
    isLoading: boolean;
}

const PlatformOrderingDashboardContent: React.FC<PlatformOrderingDashboardContentProps> = (props) => {
    return (
        <PlatformDashboardShell
            title="Platform Ordering"
            variant="ordering"
            organizations={props.organizations}
            managementOrganizations={props.managementOrganizations}
            appNameMap={props.appNameMap}
            selectedAppLiveStatusMap={props.selectedAppLiveStatusMap}
            entityNameMap={props.entityNameMap}
            representativeAppId={props.representativeAppId}
            platformAppIdsByOrganizationId={props.platformAppIdsByOrganizationId}
            loadErrors={props.loadErrors}
            discoveryProgress={props.discoveryProgress}
            onReload={props.onReload}
            isLoading={props.isLoading}
            canEditHealthThresholds={props.canManageQueues}
            currentUserEmail={props.currentUserEmail}
            DashboardComponent={AIOrderingDashboardWithProvider}
            ManagementComponent={props.canManageQueues ? PlatformOrderingManagement : undefined}
        />
    );
};

export default PlatformOrderingDashboardContent;
